import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';
import { ContactService } from '../../services/contact.service';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactComponent implements OnInit {
  formGroup: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private contactService: ContactService,
    private snackbar: SnackbarService,
    public translate: TranslocoService
  ) {}

  ngOnInit() {
    this.formGroup = this.fb.group({
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      email: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      message: ['', [Validators.required]],
      company: ['Flygets Kund', []],
      language: 'sv',
      site: ['shuttlebuss.se', []]
    });
    console.log(this.formGroup);
  }

  onSubmit(formData) {
    console.log(formData);

    this.contactService
      .contact(
        formData.email,
        formData.firstname,
        formData.lastname,
        formData.phone,
        formData.message,
        formData.company,
        formData.language
      )
      .subscribe(result => {
        if (result) {
          this.snackbar.openSnackBar('Du har skickat iväg din fråga', 'OK');
          this.formGroup.reset();
        } else {
          this.snackbar.openSnackBar('Någonting gick fel', 'OK');
        }
      });
  }
}
